import React from 'react';
import i18next from 'i18next';
import Modal from '../../StyledComponents/Modal';
import Content from '../../StyledComponents/Content';

interface DemoCarModalProps {
  onClose: () => void;
}

const DemoCarModal = ({ onClose }: DemoCarModalProps) => (
  <Modal title={i18next.t('item.demoCar')} onClose={onClose}>
    <Content>
      <p>
      {i18next.t('item.demoCarDescription')}
      </p>
    </Content>
  </Modal>
);

export default DemoCarModal;
